import { Payer } from "@wingspanhq/wingspan-api-sdk";
import { selectorCounterpartyDisplayName } from "./selectorCounterpartyDisplayName";

/**
 * Resolves a human-readable display name for a v3 Payer (client). Thin Payer-typed
 * entry point over the shared counterparty derivation ([[selectorCounterpartyDisplayName]]);
 * replaces the v1 `wsName` derivation that relied on the embedded member/user the
 * lean v3 `Payer` no longer carries.
 */
export const selectorPayerDisplayName = (payer: Payer): string =>
  selectorCounterpartyDisplayName(payer);
